import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ICoreMemberDTO } from '@app/core/model';
import { MemberContextService } from '@app/core/services/context/factory';
import { ShellService } from '@mynexus/mfe-core';
import { Observable } from 'rxjs';

@Injectable()
export abstract class SharedMemberService implements MemberContextService {
  protected readonly API_URL;

  constructor(
    public http: HttpClient,
    protected shellService: ShellService,
    @Inject('stream') private readonly stream: string
  ) {
    this.API_URL = shellService.getBaseUrlFor(stream);
  }

  getMemberByAuthNumber(tenantId: string, authNumber: string): Observable<ICoreMemberDTO> {
    return this.http.get<ICoreMemberDTO>(`${this.getBaseUrl(tenantId)}/authorizations/${authNumber}/member`);
  }

  abstract mapMemberDTO(authorizationDto: object): ICoreMemberDTO;

  protected getBaseUrl(tenantId: string): string {
    return `${this.API_URL}/tenants/${tenantId}`;
  }
}
